const languages = {
  ro: {
    general: {
      title: "Configurator gard aluminiu",
      steps: {
        one: "Model",
        two: "Dimensiuni",
        three: "Configuratie",
        four: "Culoare",
        five: "Lamele",
        six: "Oferta",
      },
      buttons: {
        next: "Continua",
        previous: "Inapoi",
        offer: "Oferta de pret",
      },
    },
    model: {
      main_title: "Alegeti modelul de gard dorit",
      model1: "Model orizontal",
      model2: "Model vertical",
      alert: "Disponibil din 15 februarie!",
    },
    dimensions: {
      main_title: "Dimensiunile gardului",
      subtitles: {
        width: "Lungimea totala a gardului (inclusiv stalpii)",
        height: "Inaltimea totala a gardului (inclusiv soclul)",
        small_height: "Inaltimea soclului (parapetului)",
      },
      meter: "metru",
      meters: "metri",
    },
    configuration: {
      main_title: "Configuratia gardului",
      labels: {
        label_obj1: "Doriti porti auto?",
        label_obj11: "Doriti poarta pietonala integrata in poarta auto?",
        label_piece1: "Selectati numarul portilor auto",
        label_obj2: "Doriti porti pietonale?",
        label_piece2: "Selectati numarul portilor pietonale",
        label_obj3: "Doriti panouri de gard?",
        label_obj31: "Panouri cu rama?",
        label_piece3: "Numarul total de panouri",
        desc_text1: "Lungimea de referinta a unui panou:",
        desc_text2:
          "Numarul minim si maxim de panouri este calculat pe baza lungimii totale a gardului de ",
        desc_text3: "si in functie de numarul si dimensiunile portilor.",
        alert_text1: "Atentie!",
        alert_text2: "Pretul panourilor cu rama este mai mare cu 20% decat cel al panourilor fara rama.",
        alert_text3: "La portile culisante se vor adauga automat 500 mm in plus fata de distanta dintre stalpi.",
        field_label: "Latime gol",
        field_label_pp: "Latime poarta pietonala",
        swing: "batanta",
        sliding: "culisanta",
        autocarrying: "autoportanta",
        yes: "Da",
        no: "Nu",
        piece: "buc",
        minimum: "minim",
        maximum: "maxim",
      },
    },
    color: {
      main_title: "Alegeti culoarea gardului",
      info_text:
        "Culoarea produsului este orientativa. Ea poate fi afisata diferit in functie de monitorul d-vostra.",
    },
    panel: {
      main_title: "Dispunerea lamelelor",
      labels: {
        label1: "Selectati latimea lamelei",
        label2: "Distanta dintre lamele",
        small: "mica",
        medium: "medie",
        big: "mare",
      },
      info_text1:
        "Modificarea dimensiunii lamelei sau a spatiului dintre lamele nu modifica pretul pe m².",
      info_text2:
        "Distanta efectiva dintre lamele se stabilieste impreuna cu clientul in momentul masuratorilor.", 
    },
    offer: {
      main_title: "Rezumat",
      labels: {
        model: "Model: ",
        color: "Culoare: ",
        profile_width: "Latime profil lamela: ",
        profile_distance: "Distanta dintre profile: ",
        total_area: "Suprafata totala: ",
        panels_area: "Suprafata panouri: ",
        person_area: "Suprafata poarta pietonala: ",
        person_areas: "Suprafata porti pietonale: ",
        car_area: "Suprafata poarta auto: ",
        car_areas: "Suprafata porti auto: "
      },
      subtitle: "Oferta de pret",
      contact_details: "Date contact",
      underline_text:
        "Pentru a obtine oferta de pret este necesar sa introduceti detaliile de mai jos",
      fields_labels: {
        fullname: "Nume",
        name: "Nume",
        surname: "Prenume",
        email: "Email",
        phone: "Telefon",
        county: "Judet",
        choose_county: "Alegeti judetul",
        choose_timeframe: "Cand planuiti gardul?",
        placeholder_timeframe: "Alegeti",
        callme: "Doriti sa fiti sunat?"
      },
      timeframe_items: ["cat mai repede posibil", "in curand", "in termen de jumatate de an", "deocamdata doar ma interesez"],
      info_text1: "Uneori oferta intra in SPAM. Va rugam sa verificati.",
      info_text2:
        "Datele d-voastră personale vor fi utilizate pentru procesarea cererii de oferta conform politicii noastre de confidentialitate disponibila pe ",
      buttons: {
        download: "Descarca oferta gard",
        email: "Vreau sa primesc oferta pe email",
      },
      newsletter: {
        title: "Doriti sa pastram legatura?",
        desc1: "Abonati-va la newsletter-ul nostru pentru a primi informatii si oferte personalizate.",
        desc2: "Nu va faceti griji, dacă va razganditi, va puteti dezabona oricand."
      },
      callback: {
        title: "Vreau sa fiu contactat",
        underline_text: "Completati urmatoarele informatii",
        thank_you_msg: "Va multumumim pentru interes",
        desc1: "Un reprezentant iSTRUCT va va contacta in cel mai scurt timp"
      },
      form_validation: {
        required: "Camp obligatoriu",
        max_length: "Max 20 caractere",
        name: "Nume invalid. Fara caractere speciale!",
        email: "Email invalid",
        phone: "Telefon invalid",
        county: "Judet invalid",
      },
      alerts: {
        name: "Completati numele",
        surname: "Completati prenumele",
        email: "Completati adresa de email",
        phone: "Completati numarul de telefon",
        county: "Completati judetul",
        timeframe: "Completati intervalul de timp",
        success: "Oferta dvs este salvata! O puteti obtine imediat accesand unul dintre butoanele de mai jos.",
        failed: "Corectati erorile din formular!",
        concrete_alert1: "Oferta nu include stalpii si nici fundatia din beton!",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "oferta_gard.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl", "CUI: RO 35671874", "RegCom: J2016000468359"],
        address: ["Adresa:", "Strada Caprioarei nr.11", "307200 Ghiroda, jud. Timis"],
        contact: ["Email: office@i-struct.ro", "https://i-struct.ro", "https://garduri-aluminiu.ro"],
      },
      footer: {
        add_msg1:
          "• Daca ati introdus datele corect, configuratorul de gard genereaza un pret care coincide 95% cu realitatea.",
        add_msg2: "• Aceasta oferta nu va obliga la nimic.",
        add_msg3: "• Valabilitatea ofertei este de 10 zile.",
        price_msg1: "Pretul total include transportul si montajul gardului in",
        price_msg2: "Valoarea finala a facturii va fi calculata in lei la cursul de schimb al Bancii Transilvania din data facturarii.",
        no_montage: "NU include montaj",
        VAT_text: "TVA inclus",
        message:
          "Daca doriti detalii si/sau doriti sa continuam demersul realizarii gardului dvs, va rugam sa ne contactati la numarul de telefon si/sau pe emailul de mai jos.",
        email: "office@cuprolli.ro",
        phone: "0724 083 039",
        // phone: "0732 823 808",
        web: "https://garduri-aluminiu.ro/proiecte-realizate"
      },
      labels: {
        to: "Catre:",
        email: "Email:",
        phone: "Telefon:",
        name: "Nume:"
      },
      main_title: "OFERTA DE PRET - GARD DIN ALUMINIU VOPSIT ELECTROSTATIC",
      price_title: "Gard din aluminiu vopsit electrostatic",
      image_info: "* Poza are caracter exemplificativ",
      features_title: "CARACTERISTICI GENERALE",
      features: [
        "- profile din aluminiu",
        "- vopsit in camp electrostatic",
        "- vopsea aplicata termic",
        "- prindere mecanica cu popnituri vopsite electrostatic",
        "- fara sudura",
      ],
    },
  },
  hu: {
    general: {
      title: "Alumínium kerítés konfigurátor",
      steps: {
        one: "Modell",
        two: "Méretek",
        three: "Konfiguráció",
        four: "Szín",
        five: "Lamellák",
        six: "Ajánlat",
      },
      buttons: {
        next: "Folytassa",
        previous: "Vissza",
        offer: "Árajánlat",
      },
    },
    model: {
      main_title: "Válassza ki a kívánt kerítésmodellt",
      model1: "Vízszintes modell",
      model2: "Függőleges modell",
      alert: "Elérhető 2021 február 15.-től!!!",
    },
    dimensions: {
      main_title: "A kerítés méretei",
      subtitles: {
        width: "A kerítés teljes hossza (oszlopokkal együtt)",
        height: "A kerítés teljes magassága",
        small_height: "A mellvéd magassága",
      },
      meter: "méter",
      meters: "méter",
    },
    configuration: {
      main_title: "Kerítés konfigurációja",
      labels: {
        label_obj1: "Autóbejáratot szeretne?",
        label_obj11: "Szeretne gyalogos bejárót, kisajtót is beépíteni a nagykapuba?",
        label_piece1: "Válassza ki az autóbejárat számát",
        label_obj2: "Szeretne gyalogos bejáratot?",
        label_piece2: "Válassza ki a gyalogos bejáratok számát",
        label_obj3: "Kerítéspanelek",
        label_obj31: "Keretes panelek?",
        label_piece3: "A panelek száma összesen",
        desc_text1: "A panel referencia hossza:",
        desc_text2: "A panelek minimális és maximális számát az ",
        desc_text3:
          "kerítésének teljes hossza alapján, a kapuk számától és méretétől függően kell kiszámítani.",
        alert_text1: "Legyen óvatos!",
        alert_text2: "A keretes panelek ára 20% -kal magasabb, mint a keret nélküli paneleké.",
        alert_text3: "Az oszlopok közötti távolságon felül 500 mm automatikusan hozzáadódik a gördülőkapuhoz. Ezeken a részeken kapnak helyet a fogadó egységek és az estleges automatizálás.",
        field_label: "Szélesség",
        field_label_pp: "Szélesség gyalogos bejárat",
        swing: "lengő kapu",
        sliding: "csúszó kapu",
        autocarrying: "önhordó kapu",
        yes: "Igen",
        no: "Nem",
        piece: "db",
        minimum: "minimális",
        maximum: "maximális",
      },
    },
    color: {
      main_title: "Válassza ki a kerítés színét",
      info_text:
        "A termék színe indikatív. A képernyő beállítástól függően eltérően jelenik meg.",
    },
    panel: {
      main_title: "A lamellák elrendezése",
      labels: {
        label1: "Válassza ki a lamellák szélességét",
        label2: "A lamellák közötti távolság",
        small: "kicsi",
        medium: "közepes",
        big: "nagy",
      },
      info_text1: "",
      info_text2:
        "A lamellák közötti tényleges távolságot a vevővel közösen állapítjuk meg a személyes felméréskor.",
    },
    offer: {
      main_title: "Összefoglalás",
      labels: {
        model: "Modell: ",
        color: "Szín: ",
        profile_width: "Lamellás profil szélessége: ",
        profile_distance: "Profilok közötti távolság: ",
        total_area: "Teljes terület: ",
        panels_area: "Panel területe: ",
        person_area: "Gyalogos kapu terület: ",
        person_areas: "Gyalogos kapu terület: ",
        car_area: "Autókapu területe: ",
        car_areas: "Autókapu területe: ",
      },
      subtitle: "Árajánlat",
      contact_details: "Kapcsolattartási adatok",
      underline_text:
        "Az árajánlat megszerzéséhez meg kell adnia az alábbiakat",
      fields_labels: {
        fullname: "Név",
        name: "Név",
        surname: "Keresztnév",
        email: "E-mail",
        phone: "Telefon",
        county: "Megyét",
        choose_county: "Válassza ki a megyét",
        choose_timeframe: "Mikorra tervezi a kerítést?",
        placeholder_timeframe: "Válassza",
        callme: "Visszahívást kérek!"
      },
      timeframe_items: ["Minél előbb", "Hamarosan", "Fél éven belül", "Egyelőre csak érdeklődöm"],
      info_text1: "",
      info_text2: `Személyes adatait a honlapunk oldalon elérhető adatvédelmi üzletpolitikánknak megfelelően kizárólag az ajánlatküldéshez használjuk fel.`,
      newsletter: {
        title: "",
        desc1: "",
        desc2: ""
      },
      buttons: {
        download: "Töltse le a PDF-ajánlatot",
        email: "Az ajánlatot e-mailben szeretném megkapni",
      },
      form_validation: {
        required: "Kötelezően kitöltendő mező",
        max_length: "Maximális hossz: 20 karakter",
        name: "Érvénytelen név, kérem ne használjon különleges karaktereket",
        email: "Érvénytelen e-mail cím",
        phone: "Érvénytelen telefon",
        county: "Érvénytelen megye/város",
      },
      alerts: {
        name: "Kérem adja meg a vezetéknevét",
        surname: "Kérem adja meg a keresztnevét",
        email: "Kérem adja meg az e-mail címét",
        phone: "Kérem adja meg a telefonszámát",
        county: "Kérem adja meg a megyét",
        timeframe: "Adja meg az időtartományt",
        success: "Az ajánlatkérés sikeresen továbbítva lett!",
        failed: "Kérem javítsa ki a hibákat!",
        concrete_alert1: "Az ajánlat nem tartalmazza sem a beton alapot, sem pedig a beton oszlopokat!",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "kerites_ajanlat.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl", "EU adószámr: RO 35671874", "Cégjegyzék szám: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, Timis megye", "Románia"],
        contact: ["E-mail: export@i-struct.eu", "Web: https://i-struct.hu"],
      },
      footer: {
        add_msg1:
          "• Amennyiben helyesen adta meg az adatokat, úgy a konfigurátor által generált ár 95%-ban megegyezik a valós árral.",
        add_msg2: "• Ez az ajánlat semmire sem kötelezi Önt.",
        add_msg3: "• Az ajánlat 10 napig érvényes.",
        price_msg1: "A vállalási ár tartalmazza a felmérés, szállítás és a beépítés költségeit",
        price_msg2: "Felmérési, szállítási és szerelési költségek",
        no_montage: "NEM tartalmazza az összeszerelést.",
        price_no_VAT_msg: "Az ár áfaalany cégeknek, érvényes EU adószámmal a VIES-ben:",
        price_VAT_msg: "Az ár magánszemélyek vagy nem áfaalany vállalkozások számára:",
        VAT_text: "Áfát tartalmaz (21%)",
        message:
          "Amennyiben további tájékoztatásra, vagy segítségre van szüksége a rendelés leadásához, úgy kérjük vegye fel velünk a kapcsolatot az alábbi telefonszámon vagy e-mail címen.",
        email: "export@i-struct.eu",
        phone: "+36 307 502 994",
        name: "Patrick Erdei",
        web: "https://i-struct.hu/projektek"
      },
      labels: {
        to: "Címzett:",
        email: "E-mail:",
        phone: "Telefon:",
        name: "Név"
      },
      main_title: "AJÁNLAT - ELEKTROSZTATIKUSAN PORSZÓRT ALUMÍNIUM KERÍTÉS",
      price_title: "Elektrosztatikusan porszórt alumínium kerítés",
      image_info: "* A kép illusztráció",
      features_title: "JELLEMZÕK",
      features: [
        "- alumínium profilok",
        "- elektrosztatikusan porszórva",
        "- termikusan felhordott porfesték",
        "- mechanikus rögzítés elektrosztatikusan festett kötõelemekkel",
        "- hegesztés nélkül",
      ],
    },
  },
  de: {
    general: {
      title: "Alu Zaun-Konfigurator",
      steps: {
        one: "Modell",
        two: "Maße",
        three: "Konfiguration",
        four: "Farbe",
        five: "Lamellen",
        six: "Angebot",
      },
      buttons: {
        next: "Weiter",
        previous: "Zurück",
        offer: "Preisangebot",
      },
    },
    model: {
      main_title: "Wählen Sie das gewünschte Zaunmodell",
      model1: "Horizontales Modell",
      model2: "Vertikales Modell",
      alert: "Erhältlich ab 30 April!",
    },
    dimensions: {
      main_title: "Maße des Zaunes",
      subtitles: {
        width: "Gesamtlänge des Zauns (einschließlich Pfosten)",
        height: "Gesamthöhe des Zauns (einschließlich Brüstung)",
        small_height: "Brüstungshöhe",
      },
      meter: "Meter",
      meters: "Meter",
    },
    configuration: {
      main_title: "Konfiguration des Zaunes",
      labels: {
        label_obj1: "Möchten Sie Ihr Toren für Kraftwagen?",
        label_obj11: "Möchten Sie ein in das Kraftwagen Tor integriertes Fußgängertor?",
        label_piece1: "Wählen Sie die Anzahl der Toren für Kraftwagen",
        label_obj2: "Möchten Sie Fußgängertore?",
        label_piece2: "Wählen Sie die Anzahl der Fußgängerpforten",
        label_obj3: "Möchten Sie Zaunpaneele?",
        label_obj31: "Gerahmte Paneele?",
        label_piece3: "Gesamtzahl der Paneele",
        desc_text1: "Referenzlänge einer Paneele:",
        desc_text2:
          "Die minimale und maximale Anzahl der Paneele wird auf der Grundlage der Gesamtlänge des Zauns von ",
        desc_text3: "entsprechend der Anzahl und Größe der Tore berechnet.",
        alert_text1: "Achtung!",
        alert_text2: "Der Preis für gerahmte Paneele ist 20 % höher als für rahmenlose Paneele.",
        alert_text3: "Bei Schiebetoren werden automatisch 500 mm mehr als der Abstand zwischen den Pfosten addiert.",
        field_label: "Breite der Lücke",
        field_label_pp: "Breite des Fußgängertors",
        swing: "Zweiflügeltor",
        sliding: "Schiebetor",
        autocarrying: "freistehend Schiebetor",
        yes: "Ja",
        no: "Nein",
        piece: "St.",
        minimum: "Minimum",
        maximum: "Maximum",
      },
    },
    color: {
      main_title: "Wählen Sie Ihre Zaunfarbe",
      info_text:
        "Die Produktfarbe ist indikativ. Sie kann je nach Monitor unterschiedlich dargestellt werden.",
    },
    panel: {
      main_title: "Anordnung der Lamellen",
      labels: {
        label1: "Lamellenbreite wählen",
        label2: "Abstand zwischen den Lamellen",
        small: "kleine",
        medium: "mittelere",
        big: "große",
      },
      info_text1:
        "Wenn Sie die Größe der Lamellen oder den Abstand zwischen den Lamellen ändern, ändert sich der Preis pro m² nicht.",
      info_text2:
        "Der tatsächliche Abstand zwischen den Lamellen wird zum Zeitpunkt der Messung gemeinsam mit dem Kunden festgelegt.",
    },
    offer: {
      main_title: "Übersicht",
      labels: {
        model: "Modell: ",
        color: "Farbe: ",
        profile_width: "Breite des Lamellenprofils: ",
        profile_distance: "Abstand zwischen den Lamellen: ",
        total_area: "Gesamtfläche: ",
        panels_area: "Bereich der Zaunpaneele: ",
        person_area: "Bereich der Fußgängertor: ",
        person_areas: "Bereich der Fußgängertore: ",
        car_area: "Bereich der Toren für Kraftwagen: ",
        car_areas: "Bereich der Toren für Kraftwagen: "
      },
      subtitle: "Preisangebot",
      contact_details: "Kontaktinformationen",
      underline_text:
        "Um den Kostenvoranschlag zu erhalten, müssen Sie die folgenden Angaben machen.",
      fields_labels: {
        fullname: "Name",
        name: "Nachname",
        surname: "Vorname",
        email: "E-mail",
        phone: "Telefon",
        county: "Land",
        choose_county: "Land wählen",
        choose_timeframe: "Wann planen Sie den Zaun?",
        placeholder_timeframe: "Wählen Sie",
        callme: "Möchten Sie angerufen werden?"
      },
      timeframe_items: ["so bald wie möglich", "bald", "innerhalb eines halben Jahres", "Ich schaue es mir gerade erst an"],
      info_text1: "Bitte überprüfen Sie Ihren Inbox und Spam-Ordner.",
      info_text2:
        "Ihre persönlichen Daten werden für die Bearbeitung Ihrer Anfrage gemäß unserer Datenschutzrichtlinie verwendet, die unter folgender Adresse abrufbar ist ",
      buttons: {
        download: "Download PDF-Angebot",
        email: "Ich möchte das Angebot per E-Mail erhalten",
      },
      callback: {
        title: "Ich möchte kontaktiert werden",
        underline_text: "Bitte geben Sie die folgenden Informationen ein",
        thank_you_msg: "Danke für Ihre Anfrage",
        desc1: "Ein Mitarbeiter von iSTRUCT wird sich in Kürze mit Ihnen in Verbindung setzen."
      },
      form_validation: {
        required: "Pflichtfeld",
        max_length: "Maximal 20 Zeichen",
        name: "Ungültiger Name. Keine Sonderzeichen!",
        email: "E-mail ungültig",
        phone: "Telefon ungültig",
        county: "Land ungültig",
      },
      alerts: {
        name: "Geben Sie Ihren Nachnamen ein",
        surname: "Geben Sie Ihren Vornamen ein",
        email: "Geben Sie Ihre E-Mail-Adresse ein",
        phone: "Geben Sie Ihre Telefonnummer ein",
        county: "Geben Sie den Land ein",
        timeframe: "Geben Sie den Zeitbereich an",
        success: "Ihr persönliches Angebot wurde automatisch erstellt. Sie können es sofort abrufen, indem Sie auf eine der Schaltflächen unten klicken.",
        failed: "Berichtigen Sie die Fehler im Formular!",
        concrete_alert1: "Im Preis enthalten sind die Zaun- und Toranlagen (konfigurationsabhängig) inklusive Zubehör.",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "zaun_angebot.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl","USt-IdNr: RO 35671874", "Handelsregister: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, Kreis Timis", "Rumänien"],
        contact: ["E-mail: export@i-struct.eu", "Web: https://i-struct.de"],
      },
      footer: {
        add_msg1:
          "• Nicht enthalten sind Pfosten und Betonfundamente.",
        add_msg2: "• Sollten Sie keine bauseitigen Stein- oder Betonpfosten haben, bieten wir Ihnen gerne passende Aluminium-Pfosten für Ihr Projekt an.",
        add_msg3: "• Nicht im Preis enthalten sind Aufmaß, Transport und Montage.",
        add_msg4: "• Dieses Angebot ist unverbindlich, 10 Tage lang gültig und verpflichtet Sie zu nichts.",
        price_msg1: "Der Gesamtpreis umfasst den Transport und die Montage des Zauns in",
        price_msg2: "Transport- und Montagekosten",
        no_montage: "KEINE Installation enthalten.",
        price_no_VAT_msg: "Der Preis gilt für mehrwertsteuerpflichtige Unternehmen mit einem gültigen Code im MIAS (VIES):",
        price_VAT_msg: "Der Preis für Privatpersonen oder Unternehmen, die nicht für die MwSt. registriert sind:",
        VAT_text: "Inklusive MwSt. (21%)",
        message:
          "Wenn Sie weitere Informationen wünschen und/oder mit der Realisierung Ihres Zauns fortfahren möchten, kontaktieren Sie uns bitte unter der unten stehenden E-Mail.",
        email: "export@i-struct.eu",
        phone: "+43 681 20265171",
        name: "Patrick Erdei",
        web: "https://i-struct.de/projekte"
      },
      labels: {
        to: "An:",
        email: "E-mail:",
        phone: "Telefon:",
        name: "Name:"
      },
      main_title: "PREISANGEBOT - ELEKTROSTATISCH LACKIERTER ALUMINIUMZAUN",
      price_title: "Elektrostatisch lackierter Aluminiumzaun",
      image_info: "* Die Bilder sind nur zur Veranschaulichung",
      features_title: "ALLGEMEINE MERKMALE",
      features: [
        "- Aluminiumprofile",
        "- elektrostatische Feldlackierung",
        "- thermisch aufgebrachte Farbe",
        "- mechanische Befestigung mit elektrostatisch lackierten Stiften",
        "- nahtlos",
      ],
    },
  },
  at: {
    general: {
      title: "Alu Zaun-Konfigurator",
      steps: {
        one: "Modell",
        two: "Maße",
        three: "Konfiguration",
        four: "Farbe",
        five: "Lamellen",
        six: "Angebot",
      },
      buttons: {
        next: "Weiter",
        previous: "Zurück",
        offer: "Preisangebot",
      },
    },
    model: {
      main_title: "Wählen Sie das gewünschte Zaunmodell",
      model1: "Horizontales Modell",
      model2: "Vertikales Modell",
      alert: "Erhältlich ab 30 April!",
    },
    dimensions: {
      main_title: "Maße des Zaunes",
      subtitles: {
        width: "Gesamtlänge des Zauns (einschließlich Pfosten)",
        height: "Gesamthöhe des Zauns (einschließlich Brüstung)",
        small_height: "Brüstungshöhe",
      },
      meter: "Meter",
      meters: "Meter",
    },
    configuration: {
      main_title: "Konfiguration des Zaunes",
      labels: {
        label_obj1: "Möchten Sie Ihr Toren für Kraftwagen?",
        label_obj11: "Möchten Sie ein in das Kraftwagen Tor integriertes Fußgängertor?",
        label_piece1: "Wählen Sie die Anzahl der Toren für Kraftwagen",
        label_obj2: "Möchten Sie Fußgängertore?",
        label_piece2: "Wählen Sie die Anzahl der Fußgängerpforten",
        label_obj3: "Möchten Sie Zaunpaneele?",
        label_obj31: "Gerahmte Paneele?",
        label_piece3: "Gesamtzahl der Paneele",
        desc_text1: "Referenzlänge einer Paneele:",
        desc_text2:
          "Die minimale und maximale Anzahl der Paneele wird auf der Grundlage der Gesamtlänge des Zauns von ",
        desc_text3: "entsprechend der Anzahl und Größe der Tore berechnet.",
        alert_text1: "Achtung!",
        alert_text2: "Der Preis für gerahmte Paneele ist 20 % höher als für rahmenlose Paneele.",
        alert_text3: "Bei Schiebetoren werden automatisch 500 mm mehr als der Abstand zwischen den Pfosten addiert.",
        field_label: "Breite der Lücke",
        field_label_pp: "Breite des Fußgängertors",
        swing: "Zweiflügeltor",
        sliding: "Schiebetor",
        autocarrying: "freistehend Schiebetor",
        yes: "Ja",
        no: "Nein",
        piece: "St.",
        minimum: "Minimum",
        maximum: "Maximum",
      },
    },
    color: {
      main_title: "Wählen Sie Ihre Zaunfarbe",
      info_text:
        "Die Produktfarbe ist indikativ. Sie kann je nach Monitor unterschiedlich dargestellt werden.",
    },
    panel: {
      main_title: "Anordnung der Lamellen",
      labels: {
        label1: "Lamellenbreite wählen",
        label2: "Abstand zwischen den Lamellen",
        small: "kleine",
        medium: "mittelere",
        big: "große",
      },
      info_text1:
        "Wenn Sie die Größe der Lamellen oder den Abstand zwischen den Lamellen ändern, ändert sich der Preis pro m² nicht.",
      info_text2:
        "Der tatsächliche Abstand zwischen den Lamellen wird zum Zeitpunkt der Messung gemeinsam mit dem Kunden festgelegt.",
    },
    offer: {
      main_title: "Übersicht",
      labels: {
        model: "Modell: ",
        color: "Farbe: ",
        profile_width: "Breite des Lamellenprofils: ",
        profile_distance: "Abstand zwischen den Lamellen: ",
        total_area: "Gesamtfläche: ",
        panels_area: "Bereich der Zaunpaneele: ",
        person_area: "Bereich der Fußgängertor: ",
        person_areas: "Bereich der Fußgängertore: ",
        car_area: "Bereich der Toren für Kraftwagen: ",
        car_areas: "Bereich der Toren für Kraftwagen: "
      },
      subtitle: "Preisangebot",
      contact_details: "Kontaktinformationen",
      underline_text:
        "Um den Kostenvoranschlag zu erhalten, müssen Sie die folgenden Angaben machen",
      fields_labels: {
        fullname: "Name",
        name: "Nachname",
        surname: "Vorname",
        email: "E-mail",
        phone: "Telefon",
        county: "Land",
        choose_county: "Land wählen",
        choose_timeframe: "Wann planen Sie den Zaun?",
        placeholder_timeframe: "Wählen Sie",
        callme: "Möchten Sie angerufen werden?"
      },
      timeframe_items: ["so bald wie möglich", "bald", "innerhalb eines halben Jahres", "Ich schaue es mir gerade erst an"],
      info_text1: "Bitte überprüfen Sie Ihren Inbox und Spam-Ordner.",
      info_text2:
        "Ihre persönlichen Daten werden für die Bearbeitung Ihrer Anfrage gemäß unserer Datenschutzrichtlinie verwendet, die unter folgender Adresse abrufbar ist ",
      buttons: {
        download: "Download PDF-Angebot",
        email: "Ich möchte das Angebot per E-Mail erhalten",
      },
      callback: {
        title: "Ich möchte kontaktiert werden",
        underline_text: "Bitte geben Sie die folgenden Informationen ein",
        thank_you_msg: "Danke für Ihre Anfrage",
        desc1: "Ein Mitarbeiter von iSTRUCT wird sich in Kürze mit Ihnen in Verbindung setzen."
      },
      form_validation: {
        required: "Pflichtfeld",
        max_length: "Maximal 20 Zeichen",
        name: "Ungültiger Name. Keine Sonderzeichen!",
        email: "E-mail ungültig",
        phone: "Telefon ungültig",
        county: "Land ungültig",
      },
      alerts: {
        name: "Geben Sie Ihren Nachnamen ein",
        surname: "Geben Sie Ihren Vornamen ein",
        email: "Geben Sie Ihre E-Mail-Adresse ein",
        phone: "Geben Sie Ihre Telefonnummer ein",
        county: "Geben Sie den Land ein",
        timeframe: "Geben Sie den Zeitbereich an",
        success: "Ihr persönliches Angebot wurde automatisch erstellt. Sie können es sofort abrufen, indem Sie auf eine der Schaltflächen unten klicken.",
        failed: "Berichtigen Sie die Fehler im Formular!",
        concrete_alert1: "Das Angebot beinhaltet nicht die Masten oder das Betonfundament!",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "zaun_angebot.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl","USt-IdNr: RO 35671874", "Handelsregister: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, Kreis Timis", "Rumänien"],
        contact: ["E-mail: export@i-struct.eu", "Web: https://i-struct.at"],
      },
      footer: {
        add_msg1:
          "• Wenn Sie die Daten korrekt eingegeben haben, erstellt der Zaunkonfigurator einen Preis, der zu 95 % korrekt ist.",
        add_msg2: "• Dieses Angebot verpflichtet Sie zu nichts.",
        add_msg3: "• Das Angebot ist 10 Tage lang gültig.",
        price_msg1: "Der Gesamtpreis umfasst den Transport und die Montage des Zauns in",
        price_msg2: "Transport- und Montagekosten",
        no_montage: "KEINE Installation enthalten.",
        price_no_VAT_msg: "Der Preis gilt für mehrwertsteuerpflichtige Unternehmen mit einem gültigen Code im MIAS (VIES):",
        price_VAT_msg: "Der Preis für Privatpersonen oder Unternehmen, die nicht für die MwSt. registriert sind:",
        VAT_text: "Inklusive MwSt. (21%)",
        message:
          "Wenn Sie weitere Informationen wünschen und/oder mit der Realisierung Ihres Zauns fortfahren möchten, kontaktieren Sie uns bitte unter der unten stehenden E-Mail.",
        email: "export@i-struct.eu",
        phone: "+43 681 20265171",
        name: "Patrick Erdei",
        web: "https://i-struct.at/projekte"
      },
      labels: {
        to: "An:",
        email: "E-mail:",
        phone: "Telefon:",
        name: "Name:"
      },
      main_title: "PREISANGEBOT - ELEKTROSTATISCH LACKIERTER ALUMINIUMZAUN",
      price_title: "Elektrostatisch lackierter Aluminiumzaun",
      image_info: "* Die Bilder sind nur zur Veranschaulichung",
      features_title: "ALLGEMEINE MERKMALE",
      features: [
        "- Aluminiumprofile",
        "- elektrostatische Feldlackierung",
        "- thermisch aufgebrachte Farbe",
        "- mechanische Befestigung mit elektrostatisch lackierten Stiften",
        "- nahtlos",
      ],
    },
  },
  fr: {
    general: {
      title: "Configurateur de clôture en aluminium",
      steps: {
        one: "Conception",
        two: "Dimensions",
        three: "Configuration",
        four: "Couleur",
        five: "Lames",
        six: "Devis",
      },
      buttons: {
        next: "Suivant",
        previous: "Retour",
        offer: "Devis",
      },
    },
    model: {
      main_title: "Choisissez le design de clôture souhaité",
      model1: "Design horizontal",
      model2: "Design vertical",
      alert: "Disponible à partir du 15 février !",
    },
    dimensions: {
      main_title: "Dimensions de la clôture",
      subtitles: {
        width: "Longueur totale (poteaux inclus)",
        height: "Hauteur totale (socle inclus)",
        small_height: "Hauteur du socle (parapet)",
      },
      meter: "Mètre",
      meters: "Mètres",
    },
    configuration: {
      main_title: "Configuration de la clôture",
      labels: {
        label_obj1: "Souhaitez-vous un portail pour véhicule ?",
        label_obj11: "Souhaitez-vous un portillon intégré au portail ?",
        label_piece1: "Sélectionnez le nombre de portails",
        label_obj2: "Souhaitez-vous des portillons ?",
        label_piece2: "Sélectionnez le nombre de portillons",
        label_obj3: "Souhaitez-vous des panneaux de clôture ?",
        label_obj31: "Panneaux encadrés ?",
        label_piece3: "Nombre de panneaux",
        desc_text1: "Longueur de référence d'un panneau :",
        desc_text2:
          "Le nombre minimum et maximum de panneaux est calculé en fonction de la longueur totale de la clôture ",
        desc_text3: "et du nombre/dimensions des portails.",
        alert_text1: "Attention !",
        alert_text2: "Le prix des panneaux encadrés est 20 % plus élevé que celui des panneaux non encadrés.",
        alert_text3: "Pour les portails coulissants, 500 mm sont automatiquement ajoutés à l'espacement entre les poteaux.",
        field_label: "Largeur de l'écart",
        field_label_pp: "Largeur du portillon",
        swing: "Battant",
        sliding: "Coulissant",
        autocarrying: "Autoportant",
        yes: "Oui",
        no: "Non",
        piece: "Pièces",
        minimum: "minimum",
        maximum: "maximum",
      },
    },
    color: {
      main_title: "Choisir la couleur de la clôture",
      info_text:
        "La couleur du produit est donné à titre indicatif Elle peut varier selon l'affichage de votre écran.",
    },
    panel: {
      main_title: "Disposition des lames",
      labels: {
        label1: "Sélectionnez la largeur des lames",
        label2: "Espacement entre les lames",
        small: "Minimal",
        medium: "Moyen",
        big: "Large",
      },
      info_text1:
        "Modifier la largeur des lames ou l'espacement entre elles n'influe pas sur le prix au m².",
      info_text2:
        "L'espacement définitif entre les lames est fixé avec le client lors de la prise de mesures.", 
    },
    offer: {
      main_title: "Résumé",
      labels: {
        model: "Design : ",
        color: "Couleur : ",
        profile_width: "Largeur du profil de lame : ",
        profile_distance: "Espacement entre les profils : ",
        total_area: "Surface totale : ",
        panels_area: "Surface des panneaux : ",
        person_area: "Surface du portillon : ",
        person_areas: "Surface des portillons : ",
        car_area: "Surface du portail véhicule : ",
        car_areas: "Surface des portails véhicule : "
      },
      subtitle: "Devis",
      contact_details: "Coordonnées",
      underline_text:
        "Pour obtenir un devis, veuillez saisir les informations ci-dessous :",
      fields_labels: {
        fullname: "Prénom",
        name: "Prénom",
        surname: "Prénom",
        email: "Email",
        phone: "Téléphone",
        county: "Région",
        choose_county: "Sélectionnez la région",
        choose_timeframe: "Quand prévoyez-vous la pose de la clôture ?",
        placeholder_timeframe: "Choisir",
        callme: "Souhaitez-vous être contacté par téléphone ?"
      },
      timeframe_items: ["Dès que possible", "Bientôt", "D'ici 6 mois", "Pour l'instant je ne fais que me renseigner"],
      info_text1: "Parfois, le devis peut arriver dans vos courriers indésirables (SPAM). Merci de vérifier.",
      info_text2:
        "Vos données personnelles seront utilisées pour traiter la demande de devis conformément à notre politique de confidentialité disponible ici. ",
      buttons: {
        download: "Télécharger le devis clôture",
        email: "Je souhaite recevoir le devis par email",
      },
      newsletter: {
        title: "Souhaitez-vous rester en contact ?",
        desc1: "Abonnez-vous à notre lettre d'information pour recevoir des informations personnalisées et des devis.",
        desc2: "Vous pourrez vous désabonner à tout moment."
      },
      callback: {
        title: "Je souhaite être contacté",
        underline_text: "Remplissez les informations suivantes",
        thank_you_msg: "Merci de votre intérêt",
        desc1: "Un conseiller iSTRUCT vous contactera dans les plus brefs délais."
      },
      form_validation: {
        required: "Champ obligatoire",
        max_length: "20 caractères maximum",
        name: "Nom invalide Pas de caractères spéciaux !",
        email: "Email invalide",
        phone: "Numéro de téléphone invalide",
        county: "Région invalide",
      },
      alerts: {
        name: "Veuillez remplir le prénom",
        surname: "Veuillez remplir le nom",
        email: "Veuillez remplir l'adresse mail",
        phone: "Veuillez remplir le numéro de téléphone",
        county: "Veuillez remplir la région",
        timeframe: "Veuillez remplir la plage horaire",
        success: "Votre devis est enregistré ! Vous pouvez le télécharger immédiatement en cliquant sur l'un des boutons ci-dessous.",
        failed: "Corrigez les erreurs dans le formulaire !",
        concrete_alert1: "Le devis n'inclut pas les poteaux ni la base en béton !",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "devis.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl", "TVA intra: RO 35671874", "RCS: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, Dép. Timis"],
        contact: ["E-mail: export@i-struct.eu", "Web: https://i-struct.fr"],
      },
      footer: {
        add_msg1:
          "• Prix incluant clôtures et portails, ainsi que l'ensemble des accessoires.",
        add_msg2: "• Prestations de prise de mesures, transport et pose non incluses.",
        add_msg3: "• Ce devis ne vous engage à rien.",
        add_msg4: "• La proposition est valable 10 jours.",
        price_msg1: "Le prix total comprend le transport et le pose de la clôture en",
        price_msg2: "Frais de mesure /de transport / d'installation",
        no_montage: "Pose NON inclus",
        price_no_VAT_msg: "Tarifs pour les entreprises assujetties à la TVA avec un code VIES valide",
        price_VAT_msg: "Tarifs pour les particuliers ou les entreprises non assujetties à la TVA",
        VAT_text: "TVA incluse (21%)",
        message: "Pour plus de détails et/ou si vous souhaitez que nous poursuivions les démarches pour la fabrication de votre clôture, veuillez nous contacter au numéro de téléphone et/ou à l'adresse email ci-dessous.",
        email: "export@i-struct.eu",
        phone: "+33 7 58 32 32 81",
        name: "Islam Ben Khaled",
        web: "https://i-struct.fr/projets"
      },
      labels: {
        to: "À:",
        email: "E-mail:",
        phone: "Téléphone:",
        name: "Nom:"
      },
      main_title: "DEVIS - CLÔTURE EN ALUMINIUM AVEC REVÊTEMENT EN POUDRE ÉLECTROSTATIQUE",
      price_title: "Clôture en aluminium avec revêtement en poudre électrostatique",
      image_info: "* L'image est fournie à titre indicatif uniquement.",
      features_title: "CARACTÉRISTIQUES GÉNÉRALES",
      features: [
        "- Profilés en aluminium",
        "- Peinture au champ électrostatique",
        "- Peinture thermique",
        "- Fixation mécanique avec rivets peints au champ électrostatique",
        "- Sans soudure",
      ],
    },
  },
  be: {
    general: {
      title: "Configurateur de clôture en aluminium",
      steps: {
        one: "Conception",
        two: "Dimensions",
        three: "Configuration",
        four: "Couleur",
        five: "Lames",
        six: "Devis",
      },
      buttons: {
        next: "Suivant",
        previous: "Retour",
        offer: "Devis",
      },
    },
    model: {
      main_title: "Choisissez le design de clôture souhaité",
      model1: "Design horizontal",
      model2: "Design vertical",
      alert: "Disponible à partir du 15 février !",
    },
    dimensions: {
      main_title: "Dimensions de la clôture",
      subtitles: {
        width: "Longueur totale (poteaux inclus)",
        height: "Hauteur totale (socle inclus)",
        small_height: "Hauteur du socle (parapet)",
      },
      meter: "Mètre",
      meters: "Mètres",
    },
    configuration: {
      main_title: "Configuration de la clôture",
      labels: {
        label_obj1: "Souhaitez-vous un portail pour véhicule ?",
        label_obj11: "Souhaitez-vous un portillon intégré au portail ?",
        label_piece1: "Sélectionnez le nombre de portails",
        label_obj2: "Souhaitez-vous des portillons ?",
        label_piece2: "Sélectionnez le nombre de portillons",
        label_obj3: "Souhaitez-vous des panneaux de clôture ?",
        label_obj31: "Panneaux encadrés ?",
        label_piece3: "Nombre de panneaux",
        desc_text1: "Longueur de référence d'un panneau :",
        desc_text2:
          "Le nombre minimum et maximum de panneaux est calculé en fonction de la longueur totale de la clôture ",
        desc_text3: "et du nombre/dimensions des portails.",
        alert_text1: "Attention !",
        alert_text2: "Le prix des panneaux encadrés est 20 % plus élevé que celui des panneaux non encadrés.",
        alert_text3: "Pour les portails coulissants, 500 mm sont automatiquement ajoutés à l'espacement entre les poteaux.",
        field_label: "Largeur de l'écart",
        field_label_pp: "Largeur du portillon",
        swing: "Battant",
        sliding: "Coulissant",
        autocarrying: "Autoportant",
        yes: "Oui",
        no: "Non",
        piece: "Pièces",
        minimum: "minimum",
        maximum: "maximum",
      },
    },
    color: {
      main_title: "Choisir la couleur de la clôture",
      info_text:
        "La couleur du produit est donné à titre indicatif Elle peut varier selon l'affichage de votre écran.",
    },
    panel: {
      main_title: "Disposition des lames",
      labels: {
        label1: "Sélectionnez la largeur des lames",
        label2: "Espacement entre les lames",
        small: "Minimal",
        medium: "Moyen",
        big: "Large",
      },
      info_text1:
        "Modifier la largeur des lames ou l'espacement entre elles n'influe pas sur le prix au m².",
      info_text2:
        "L'espacement définitif entre les lames est fixé avec le client lors de la prise de mesures.", 
    },
    offer: {
      main_title: "Résumé",
      labels: {
        model: "Design : ",
        color: "Couleur : ",
        profile_width: "Largeur du profil de lame : ",
        profile_distance: "Espacement entre les profils : ",
        total_area: "Surface totale : ",
        panels_area: "Surface des panneaux : ",
        person_area: "Surface du portillon : ",
        person_areas: "Surface des portillons : ",
        car_area: "Surface du portail véhicule : ",
        car_areas: "Surface des portails véhicule : "
      },
      subtitle: "Devis",
      contact_details: "Coordonnées",
      underline_text:
        "Pour obtenir un devis, veuillez saisir les informations ci-dessous :",
      fields_labels: {
        fullname: "Prénom",
        name: "Prénom",
        surname: "Prénom",
        email: "Email",
        phone: "Téléphone",
        county: "Région",
        choose_county: "Sélectionnez la région",
        choose_timeframe: "Quand prévoyez-vous la pose de la clôture ?",
        placeholder_timeframe: "Choisir",
        callme: "Souhaitez-vous être contacté par téléphone ?"
      },
      timeframe_items: ["Dès que possible", "Bientôt", "D'ici 6 mois", "Pour l'instant je ne fais que me renseigner"],
      info_text1: "Parfois, le devis peut arriver dans vos courriers indésirables (SPAM). Merci de vérifier.",
      info_text2:
        "Vos données personnelles seront utilisées pour traiter la demande de devis conformément à notre politique de confidentialité disponible ici. ",
      buttons: {
        download: "Télécharger le devis clôture",
        email: "Je souhaite recevoir le devis par email",
      },
      newsletter: {
        title: "Souhaitez-vous rester en contact ?",
        desc1: "Abonnez-vous à notre lettre d'information pour recevoir des informations personnalisées et des devis.",
        desc2: "Vous pourrez vous désabonner à tout moment."
      },
      callback: {
        title: "Je souhaite être contacté",
        underline_text: "Remplissez les informations suivantes",
        thank_you_msg: "Merci de votre intérêt",
        desc1: "Un conseiller iSTRUCT vous contactera dans les plus brefs délais."
      },
      form_validation: {
        required: "Champ obligatoire",
        max_length: "20 caractères maximum",
        name: "Nom invalide Pas de caractères spéciaux !",
        email: "Email invalide",
        phone: "Numéro de téléphone invalide",
        county: "Région invalide",
      },
      alerts: {
        name: "Veuillez remplir le prénom",
        surname: "Veuillez remplir le nom",
        email: "Veuillez remplir l'adresse mail",
        phone: "Veuillez remplir le numéro de téléphone",
        county: "Veuillez remplir la région",
        timeframe: "Veuillez remplir la plage horaire",
        success: "Votre devis est enregistré ! Vous pouvez le télécharger immédiatement en cliquant sur l'un des boutons ci-dessous.",
        failed: "Corrigez les erreurs dans le formulaire !",
        concrete_alert1: "Le devis n'inclut pas les poteaux ni la base en béton !",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "devis.pdf",
      header: {
        company: ["Cuprolli Manufacturing srl", "TVA intra: RO 35671874", "RCS: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, Dép. Timis"],
        contact: ["E-mail: export@i-struct.eu", "Web: https://i-struct.be"],
      },
      footer: {
        add_msg1:
          "• Si les données ont été correctement saisies, le configurateur génère un prix avec une précision de 95%.",
        add_msg2: "• Ce devis ne vous engage à rien.",
        add_msg3: "• La proposition est valable 10 jours.",
        price_msg1: "Le prix total comprend le transport et le pose de la clôture en",
        price_msg2: "Frais de mesure /de transport / d'installation",
        no_montage: "Pose NON inclus",
        price_no_VAT_msg: "Tarifs pour les entreprises assujetties à la TVA avec un code VIES valide",
        price_VAT_msg: "Tarifs pour les particuliers ou les entreprises non assujetties à la TVA",
        VAT_text: "TVA incluse (21%)",
        message: "Pour plus de détails et/ou si vous souhaitez que nous poursuivions les démarches pour la fabrication de votre clôture, veuillez nous contacter au numéro de téléphone et/ou à l'adresse email ci-dessous.",
        email: "export@i-struct.eu",
        phone: "+33 7 58 32 32 81",
        name: "Islam Ben Khaled",
        web: "https://i-struct.be/projets"
      },
      labels: {
        to: "À:",
        email: "E-mail:",
        phone: "Téléphone:",
        name: "Nom:"
      },
      main_title: "DEVIS - CLÔTURE EN ALUMINIUM AVEC REVÊTEMENT EN POUDRE ÉLECTROSTATIQUE",
      price_title: "Clôture en aluminium avec revêtement en poudre électrostatique",
      image_info: "* L'image est fournie à titre indicatif uniquement.",
      features_title: "CARACTÉRISTIQUES GÉNÉRALES",
      features: [
        "- Profilés en aluminium",
        "- Peinture au champ électrostatique",
        "- Peinture thermique",
        "- Fixation mécanique avec rivets peints au champ électrostatique",
        "- Sans soudure",
      ],
    },
  },
  en: {
    general: {
      title: "Aluminium Fence Configurator",
      steps: {
        one: "Model",
        two: "Dimensions",
        three: "Configuration",
        four: "Color",
        five: "Slats",
        six: "Offer",
      },
      buttons: {
        next: "Continue",
        previous: "Back",
        offer: "Price quote",
      },
    },
    model: {
      main_title: "Wählen Sie das gewünschte Zaunmodell",
      model1: "Horizontales Modell",
      model2: "Vertikales Modell",
      alert: "Erhältlich ab 30 April!",
    },
    dimensions: {
      main_title: "Maße des Zaunes",
      subtitles: {
        width: "Gesamtlänge des Zauns (einschließlich Pfosten)",
        height: "Gesamthöhe des Zauns",
        small_height: "Brüstungshöhe",
      },
      meter: "Meter",
      meters: "Meter",
    },
    configuration: {
      main_title: "Fence configuration",
      labels: {
        label_obj1: "Do you want car gates?",
        label_obj11: "Do you want a pedestrian gate integrated into the car gate?",
        label_piece1: "Select the number of car gates",
        label_obj2: "Do you want pedestrian gates?",
        label_piece2: "Select the number of pedestrian gates",
        label_obj3: "Do you want fence panels?",
        label_obj31: "Fence panel with frame?",
        label_piece3: "Select the number of fence panels",
        desc_text1: "Reference length of a fence panel:",
        desc_text2:
          "The minimum and maximum number of panels is determined on the basis of the total length of the fence of ",
        desc_text3: "calculated according to the number and size of the gates.",
        alert_text1: "Caution!",
        alert_text2: "The price for framed panels is 20% higher than for frameless panels.",
        alert_text3: "For sliding gates, 500 mm more than the distance between the posts is automatically added.",
        field_label: "Width of the gap",
        field_label_pp: "Width of the pedestrian gate",
        swing: "dual-swing",
        sliding: "sliding",
        autocarrying: "self-supporting sliding",
        yes: "Yes",
        no: "No",
        piece: "Piece",
        minimum: "Minimum",
        maximum: "Maximum",
      },
    },
    color: {
      main_title: "Wählen Sie Ihre Zaunfarbe",
      info_text:
        "Die Produktfarbe ist indikativ. Sie kann je nach Monitor unterschiedlich dargestellt werden.",
    },
    panel: {
      main_title: "Anordnung der Lamellen",
      labels: {
        label1: "Lamellenbreite wählen",
        label2: "Abstand zwischen den Lamellen",
        small: "kleine",
        medium: "mittelere",
        big: "große",
      },
      info_text1:
        "Wenn Sie die Größe der Lamellen oder den Abstand zwischen den Lamellen ändern, ändert sich der Preis pro m² nicht.",
      info_text2:
        "Der tatsächliche Abstand zwischen den Lamellen wird zum Zeitpunkt der Messung gemeinsam mit dem Kunden festgelegt.",
    },
    offer: {
      main_title: "Übersicht",
      labels: {
        model: "Modell: ",
        color: "Farbe: ",
        profile_width: "Breite des Lamellenprofils: ",
        profile_distance: "Abstand zwischen den Lamellen: ",
        total_area: "Gesamtfläche: ",
        panels_area: "Bereich der Zaunpaneele: ",
        person_area: "Bereich der Fußgängertor: ",
        person_areas: "Bereich der Fußgängertore: ",
        car_area: "Bereich der Toren für Kraftwagen: ",
        car_areas: "Bereich der Toren für Kraftwagen: "
      },
      subtitle: "Preisangebot",
      contact_details: "Kontaktinformationen",
      underline_text:
        "Um den Kostenvoranschlag zu erhalten, müssen Sie die folgenden Angaben machen",
      fields_labels: {
        fullname: "Name",
        name: "Nachname",
        surname: "Vorname",
        email: "E-mail",
        phone: "Telefon",
        county: "Land",
        choose_county: "Land wählen",
        choose_timeframe: "Wann planen Sie den Zaun?",
        placeholder_timeframe: "Wählen Sie",
        callme: "Möchten Sie angerufen werden?"
      },
      timeframe_items: ["so bald wie möglich", "bald", "innerhalb eines halben Jahres", "Ich schaue es mir gerade erst an"],
      info_text1: "Manchmal geht das Angebot in SPAM. Bitte prüfen Sie das.",
      info_text2:
        "Ihre persönlichen Daten werden für die Bearbeitung Ihrer Anfrage gemäß unserer Datenschutzrichtlinie verwendet, die unter folgender Adresse abrufbar ist ",
      buttons: {
        download: "Download PDF-Angebot",
        email: "Ich möchte das Angebot per E-Mail erhalten",
      },
      callback: {
        title: "I want to be contacted",
        underline_text: "Please enter the following information",
        thank_you_msg: "Thank you for your your enquiry",
        desc1: "An iSTRUCT representative will contact you shortly."
      },
      form_validation: {
        required: "Pflichtfeld",
        max_length: "Maximal 20 Zeichen",
        name: "Ungültiger Name. Keine Sonderzeichen!",
        email: "E-mail ungültig",
        phone: "Telefon ungültig",
        county: "Land ungültig",
      },
      alerts: {
        name: "Geben Sie Ihren Nachnamen ein",
        surname: "Geben Sie Ihren Vornamen ein",
        email: "Geben Sie Ihre E-Mail-Adresse ein",
        phone: "Geben Sie Ihre Telefonnummer ein",
        county: "Geben Sie den Land ein",
        timeframe: "Specify the time range",
        success: "Your price offer was automatically created.",
        failed: "Berichtigen Sie die Fehler im Formular!",
        concrete_alert1: "Das Angebot beinhaltet nicht die Masten oder das Betonfundament!",
        concrete_alert2: ""
      },
    },
    pdf: {
      filename: "zaun_angebot.pdf",
      header: {
        company: ["VAT-ID: RO 35671874", "Trade register: J2016000468359"],
        address: ["Strada Caprioarei 11", "307200 Ghiroda, jud. Timis"],
        contact: ["E-mail: info@i-struct.eu", "Web: www.i-struct.eu"],
      },
      footer: {
        add_msg1:
          "• Wenn Sie die Daten korrekt eingegeben haben, erstellt der Zaunkonfigurator einen Preis, der zu 95 % korrekt ist.",
        add_msg2: "• Dieses Angebot verpflichtet Sie zu nichts.",
        add_msg3: "• Das Angebot ist 10 Tage lang gültig.",
        price_msg1: "Der Gesamtpreis umfasst den Transport und die Montage des Zauns in",
        price_msg2: "Der Gesamtpreis umfasst den Transport des Zauns in",
        no_montage: "KEINE Installation enthalten.",
        VAT_text: "VAT included (21%)",
        message:
          "Wenn Sie weitere Informationen wünschen und/oder mit der Realisierung Ihres Zauns fortfahren möchten, kontaktieren Sie uns bitte unter der unten stehenden E-mail.",
        email: "info@i-struct.eu",
        phone: "",
        web: "https://cuprolli.eu/de/projekte"
      },
      labels: {
        to: "An:",
        email: "E-mail:",
        phone: "Telefon:",
      },
      main_title: "PREISANGEBOT - ELEKTROSTATISCH LACKIERTER ALUMINIUMZAUN",
      image_info: "* Die Bilder sind nur zur Veranschaulichung",
      features_title: "ALLGEMEINE MERKMALE",
      features: [
        "- Aluminiumprofile",
        "- elektrostatische Feldlackierung",
        "- thermisch aufgebrachte Farbe",
        "- mechanische Befestigung mit elektrostatisch lackierten Stiften",
        "- nahtlos",
      ],
    },
  },
};

export default languages;